angular.module('ikeweb.spike.measure').value('PhotoMeasure',

    function PhotoMeasure(photogrammetryToolKit, $window, capture, imgElement, svgElement, measurementFormatter, pubSubService, measureTopics, billingService) {
        var Measurement = photogrammetryToolKit.Measurement,
            SVG = photogrammetryToolKit.SVG;
        var canvas, calibratedImage, spikeViewPort;

        var activeMeasurement;
        var isPro;


        billingService.isOnPremium().then(function(pro) {
            isPro = pro;
        });

        function canCorrectPerspective() {
            return isPro;
        }

        function setActiveMeasurement() {
            activeMeasurement = Measurement.application.getActiveMeasurement();
        }

        function activateMeasurement(uuid) {
            Measurement.application.setActiveMeasurement(uuid);
        }

        function getActiveMeasurement() {
            return activeMeasurement;
        }

        function createSVGCanvas() {
            var h, w, nh, nw;
            w = imgElement.width;
            h = imgElement.height;
            nw = imgElement.naturalWidth;
            nh = imgElement.naturalHeight;
            var svg = SVG(svgElement).size(w, h);
            svg.viewbox(0, 0, nw, nh);
            return svg;
        }

        function publishReady() {
            pubSubService.publish(measureTopics.PHOTO_MEASURE.READY);
        }

        function publishUpdate() {
            pubSubService.publish(measureTopics.PHOTO_MEASURE.UPDATE);
        }

        function create() {
            Measurement.Application.EVENTS.emitter.on(Measurement.Application.EVENTS.MEASUREMENT.LOADED, publishReady);

            Measurement.Application.EVENTS.emitter.on(Measurement.Application.EVENTS.MEASUREMENT.UPDATED, publishUpdate);

            Measurement.Application.EVENTS.emitter.on(Measurement.Application.EVENTS.MEASUREMENT.SELECTED, setActiveMeasurement);

            canvas = createSVGCanvas();
            calibratedImage = new Measurement.CalibratedImage(imgElement, capture.hva, capture.vva, capture.distance, 'height');
            spikeViewPort = new Measurement.SpikeViewport(calibratedImage);
            /*eslint-disable */
            var ikeJSBridge = new Measurement.IkeToolsLibraryClientside(canvas, calibratedImage, spikeViewPort, capture.measurements, measurementFormatter);
            /*eslint-enable */

            Measurement.application.wonkingEnabled = true;
        }

        function destroy() {
            Measurement.Application.EVENTS.emitter.off(publishReady);
            Measurement.Application.EVENTS.emitter.off(publishUpdate);
        }

        function updateAllLabels() {
            Measurement.application.updateAllLabels();
        }

        function update() {
            canvas.size(imgElement.width, imgElement.height);
            calibratedImage.updateScale();
            spikeViewPort.notifyNewZoomScale(
                calibratedImage.getImageScaleFactor()
            );
        }

        function drawAreaFromAlignment() {
            Measurement.application.drawAreaFromAlignment();
        }

        function serialize() {
            return Measurement.application.save();
        }

        function showAlignment() {
            Measurement.application.showAlignment();
            Measurement.Layer.activate('alignment');
        }

        function showMeasurement() {
            Measurement.application.showMeasurement();
            Measurement.Layer.activate('main');
        }

        function getActiveLayerKey() {
            return Measurement.application.getActiveLayerKey();
        }

        function deleteActiveHandle() {
            Measurement.application.deleteActiveHandle();
        }

        function deleteActiveMeasurement() {
            Measurement.application.deleteActiveMeasurement();
        }

        function activateLayer(layerName) {
            Measurement.Layer.activate(layerName);
        }

        function getMeasurements() {
            return Measurement.application.getMeasurements();
        }

        function getImgElement() {
            return imgElement;
        }

        function isDrawing() {
            return Measurement.application.isDrawing();
        }

        function drawAlignmentFromPoints(points) {
            Measurement.application.drawAlignmentFromPoints(points);
        }

        function enableDrawing() {
            Measurement.application.enableDrawing();
        }

        function toggleDrawing() {

            if (isDrawing()) {
                Measurement.application.disableDrawing();
            } else {
                Measurement.application.enableDrawing();
            }
        }

        function canLockRectangle() {
            var activeHandle = Measurement.application.activeHandle;
            return activeHandle == null || activeHandle.parent.canWonk();
        }

        function isRectangleLocked() {
            return Measurement.application.wonkingEnabled;
        }

        function toggleRectangleLock() {
            return Measurement.application.wonkingEnabled = !Measurement.application.wonkingEnabled;
        }

        create();

        return {
            updateAllLabels: updateAllLabels,
            update: update,
            drawAreaFromAlignment: drawAreaFromAlignment,
            serialize: serialize,
            showAlignment: showAlignment,
            showMeasurement: showMeasurement,
            getActiveLayerKey: getActiveLayerKey,
            getActiveMeasurement: getActiveMeasurement,
            activateMeasurement: activateMeasurement,
            deleteActiveHandle: deleteActiveHandle,
            deleteActiveMeasurement: deleteActiveMeasurement,
            activateLayer: activateLayer,
            getMeasurements: getMeasurements,
            getImgElement: getImgElement,
            enableDrawing: enableDrawing,
            toggleDrawing: toggleDrawing,
            isDrawing: isDrawing,
            destroy: destroy,
            canLockRectangle: canLockRectangle,
            isRectangleLocked: isRectangleLocked,
            toggleRectangleLock: toggleRectangleLock,
            drawAlignmentFromPoints: drawAlignmentFromPoints,
            canCorrectPerspective: canCorrectPerspective
        };
    });



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/measure/photo-measure/photo.measure.js
// module id = 565
// module chunks = 0